// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] + "-" + {"218":"16668c3ffd0147c1a1c2","532":"daf9d2e140857d85bc70","691":"53cc500fa6ea3600bb3f","774":"b14d85a47b2dda75fb66"}[chunkId] + ".js";
};